// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"5acd379b","592":"17e38eb2","952":"88130b9e"}[chunkId] + ".chunk.js";
};